export default "assets/images/quote-f5e2dce4.svg";